import PageModule from "@eisinc/Overrides/Pages/InvoiceDetailsPage";

export * from "@eisinc/Overrides/Pages/InvoiceDetailsPage";

export default PageModule;
